var $5343b655542a760d$exports = {};
$5343b655542a760d$exports = {
    "actions": `Toimingud`,
    "hideButtonLabel": `Kuva v\xe4hem`,
    "noTags": `Puudub`,
    "showAllButtonLabel": (args, formatter)=>`Kuva k\xf5ik (${formatter.number(args.tagCount)})`
};


export {$5343b655542a760d$exports as default};
//# sourceMappingURL=et-EE.mjs.map
